import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import CardSystem from '../../Card/CardSystem';

export class BoosterJoker extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: {
            system: CardSystem;
            jokerCard: BaseCard;
        }
    ): IterableIterator<number> {
        const transform = meta.jokerCard.getComponent(TransformComponent);

        transform.scale.set(1, 1);

        const arcYPosition = transform.y - 100;

        const tweenX = this.getTween(transform.position);
        const tweenYIN = this.getTween(transform.position);
        const tweenYOUT = this.getTween(transform.position);
        const tweenRotation = this.getTween(transform);

        tweenX.to({ x: 0 }, 1000);
        tweenX.easing(Easing.Quadratic.Out);

        tweenYIN.to({ y: arcYPosition }, 500);
        tweenYIN.easing(Easing.Quadratic.Out);

        tweenRotation.to({ rotation: Math.PI * 4 }, 1000);
        tweenRotation.easing(Easing.Cubic.Out);

        tweenX.start(this.elapsedTime);
        tweenRotation.start(this.elapsedTime);

        yield* this.startTween(tweenYIN);

        tweenYOUT.to({ y: 0 }, 500);
        tweenYOUT.easing(Easing.Quadratic.In);

        yield* this.startTween(tweenYOUT);
    }
}
